<template>
      <div>
        <div class="agreement" v-if="dialogVisible">
            <el-dialog
                class="agreement-dialog"
                title = ''
                width ="782px"
                height="409px"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                :lock-scroll="false"
                :show-close="false"
                :visible.sync="dialogVisible"
                :before-close="handleClose">
                <h1>使用协议与隐私政策</h1>
                <div class="agreement-dialog-content">
                    <p>感谢您使用资金课堂！</p> 
                    <p>为了更好的保障您的个人权益，请认真阅读 <span @click="goAgreement('https://www.capwhale.com/index/userTerms.html')">《服务协议》</span>、<span @click="goAgreement('https://www.capwhale.com/index/privacy.html')">《隐私政策》</span>的全部内容，同意并接受全部条款后开始使用我们的产品和服务，若不同意，将无法使用我们的产品和服务。</p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="agree">同意</el-button>
                </span>
            </el-dialog>
        </div>
        <!-- <InterestPopu ref="interestPopu"></InterestPopu> -->
      </div>
</template>

<script>
import {mapGetters} from 'vuex'
// import InterestPopu from './interestPopu.vue'
import Cookies from 'js-cookie'
export default {
    name: 'agreement',
    data() {
        return {
            dialogVisible: false,
            userStatus: this.user().isLogin,
        }
    },
    methods: {
        handleClose() {
            this.dialogVisible = false
        },
        goAgreement(url) { // 跳转外部链接
            window.open(url, "_blank")
        },
        startPopu() {
            // let user = this.user()
            // 判断兴趣列表是否存在，存在则不弹
            if (Cookies.get('codelist') == undefined || Cookies.get('codelist').length == 0) {
                this.dialogVisible = true
            }
        },
        agree() {
            // 关闭弹窗
            this.handleClose()
            
            // 保存cookie
            Cookies.set('agreementCookie', 1)

            this.$nextTick(() => {
                // 兴趣爱好弹窗
                this.$parent.getInterestPopu()
            })
        },
        ...mapGetters(['user'])
    },
    components: {
    }
}
</script>
<style lang="scss">
.v-modal {
    opacity: .35;
}
</style>
<style lang="scss" type="text/scss">
// .agreement {
   
    .agreement-dialog {
        .el-dialog__title {
            text-align: center
        }
        h1 {
            margin-bottom: 40px;
            font-size:24px;
            font-weight: bold;
            text-align: center;
        }
        .agreement-dialog-content {
            padding: 28px 40px;
            margin: auto;
            box-sizing: border-box;
            width:720px;
            max-height:275px;
            font-size: 16px;
            line-height: 24px;
            overflow: auto;
            border:1px solid rgba(229,229,229,1);

            span {
                color: #409EFF;
                cursor: pointer;
            }
        }
        .el-dialog__footer {
            text-align: center
        }
        .dialog-footer {
            .el-button {
                width:200px;
                height:50px;
            }
        }
    }
// }
</style>